export default class Contato {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.doadorId = 0;
        this.nome = '';
        this.cargo = '';
        this.cep = '';
        this.logradouro = '';
        this.bairro = '';
        this.cidade = '';
        this.estado = '';
        this.bairro = '';
        this.pais = '';
        this.telefone = '';
        this.ramal = '';
        this.celular = '';
        this.email = '';
        this.situacao = 'A';
        this.situacaoStr = '';

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.doadorId = model.doadorId;
        this.nome = model.nome;
        this.cargo = model.cargo;
        this.cep = model.cep;
        this.logradouro = model.logradouro;
        this.bairro = model.bairro;
        this.cidade = model.cidade;
        this.estado = model.estado;
        this.bairro = model.bairro;
        this.pais = model.pais;
        this.telefone = model.telefone;
        this.ramal = model.ramal;
        this.celular = model.celular;
        this.email = model.email;
        this.situacao = model.situacao;
        this.situacaoStr = model.situacaoStr;

    }
}